import styled from "@emotion/styled";
import { theme } from "utils/Theme";

export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
`;
export const SideBarMenuTitle = styled.div`
  padding: 0 26px;
  margin-bottom: 8px;
`;

export const SideBarWrapper = styled.div`
  flex: 1;
  margin-bottom: 32px;
  background-color: #ffffff;
`;
